import { render, staticRenderFns } from "./index.vue?vue&type=template&id=52c91f0a"
import script from "./prRecoWithGl.js?vue&type=script&lang=js&external"
export * from "./prRecoWithGl.js?vue&type=script&lang=js&external"
import style0 from "./prRecoWithGl.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports